@if (data$|async; as data) {
  @if (routes$|async; as routes) {
    <div class="grid grid-cols-2 lg:grid-cols-3 gap-5">
      @for (box of routes; track box) {
        <div class="box-container overflow-hidden">
          @if (box.icon) {
            <svg class="absolute w-20 h-20 z-10 text-sky-500">
              <use [attr.xlink:href]="box.icon"></use>
            </svg>
            <svg class="absolute z-0 w-40 h-40 z-0 -m-14 xl:-m-20 text-slate-100">
              <use [attr.xlink:href]="box.icon"></use>
            </svg>
          }
          <div class="w-2/3 ml-auto text-right relative h-full flex flex-col z-20">
            <h2 class="text-3xl font-bold">{{box.name}}</h2>
            @if (box.data; as name) {
              <div class="pt-5">
                <ul>
                  @for (datum of getCardItems(data, name); track datum) {
                    <li>
                      {{datum}}
                    </li>
                  }
                </ul>
              </div>
            }
            <div class="mt-auto pt-10">
              <a emsysButton [routerLink]="box.path" [queryParams]="box.queryParams || null" appearance="primary">
                More
                <svg class="w-5 h-5 ml-2.5">
                  <use xlink:href="assets/icons/symbols.svg#arrow-right"></use>
                </svg>
              </a>
            </div>
          </div>
        </div>
      }
    </div>
  }
}

<ng-template teleport="header">
  <greeting/>
</ng-template>
